// extracted by mini-css-extract-plugin
module.exports = {"checkEmail":"checkEmail_checkEmail__3W85w","checkEmailContent":"checkEmail_checkEmailContent__1Ay0_","icon":"checkEmail_icon__3EihG","backToLogin":"checkEmail_backToLogin__2ofyR"};